module.exports = __webpack_public_path__ + "resources/img/img_moai_protect_func_m.f3d3d8f7282df126186f40a65a4a87ad.png";